const modalConfig = {
  MODAL_QUICK_VIEW: "MODAL_QUICK_VIEW",
  MODAL_SIZE_CHART: "MODAL_SIZE_CHART",
  MODAL_PDP_ZOOM: "MODAL_PDP_ZOOM",
  MODAL_ROPIS: "MODAL_ROPIS",
  MODAL_GIFT_CARD_CHECK_BALANCE: "MODAL_GIFT_CARD_CHECK_BALANCE",
  MODAL_ADDRESS_OPERATIONS: "MODAL_ADDRESS_OPERATIONS",
  MODAL_PAYMENT_CARD: "MODAL_PAYMENT_CARD",
  MODAL_EDIT_SHIPPING_ADDRESS: "MODAL_EDIT_SHIPPING_ADDRESS",
  MODAL_ADD_SHIPPING_ADDRESS: "MODAL_ADD_SHIPPING_ADDRESS",
  MODAL_FORGOT_PASSWORD: "MODAL_FORGOT_PASSWORD",
  MODAL_CONTACT_DIAMOND_SPECIALIST: "MODAL_CONTACT_DIAMOND_SPECIALIST",
  MODAL_CONTACT_CUSTOMER_CARE: "MODAL_CONTACT_CUSTOMER_CARE",
  MODAL_EMAIL_SIGNUP: "MODAL_EMAIL_SIGNUP",
  MODAL_DELETE_PAYPAL: "MODAL_DELETE_PAYPAL",
  MODAL_DELETE_PAYMENT_CARD: "MODAL_DELETE_PAYMENT_CARD",
  MODAL_DELETE_ADDRESS: "MODAL_DELETE_ADDRESS",
  MODAL_ORDER_CONFIRMATION: "MODAL_ORDER_CONFIRMATION",
  MODAL_COUNTRY_SELECT: "MODAL_COUNTRY_SELECT",
  MODAL_EMAILPOPUP_ITEM: "MODAL_EMAILITEM_POPUP",
  MODAL_STACK_IT_WITH: "MODAL_STACK_IT_WITH",
  MODAL_ASM_NEW_CUSTOMER: "MODAL_ASM_NEW_CUSTOMER",
  MODAL_ADDITIONAL_PRODUCT_DETAILS: "MODAL_ADDITIONAL_PRODUCT_DETAILS",
  MODAL_FIND_ASM_USER_RESULTS: "MODAL_FIND_ASM_USER_RESULTS",
  MODAL_ASM_FIND_CUSTOMER: "MODAL_ASM_FIND_CUSTOMER",
  MODAL_ASM_CONFIRM_MERGE_ACCOUNTS: "MODAL_ASM_CONFIRM_MERGE_ACCOUNTS",
  MODAL_STACKER_SHARE: "MODAL_STACKER_SHARE",
  MODAL_STACKER_HELP: "MODAL_STACKER_HELP",
  MODAL_STACKER_AMOUNT: "MODAL_STACKER_AMOUNT",
  MODAL_NOTIFY_ME: "MODAL_NOTIFY_ME",
  MODAL_LOGIN: "MODAL_LOGIN",
}

export default modalConfig
